import { render } from "./UITestsLinksPage.vue?vue&type=template&id=b6dc881c"
import script from "./UITestsLinksPage.vue?vue&type=script&lang=js"
export * from "./UITestsLinksPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__